// Keep microseconds when comparing Postgres (+00:00) and cached ISO (Z) timestamps.
export const serverTimestampKey = (timestamp: string): string => {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';
  const fraction = /\.(\d+)/.exec(timestamp)?.[1] ?? '';
  return date.toISOString().slice(0, 19) + fraction.padEnd(6, '0').slice(0, 6);
};

export const acceptsServerRow = (incoming: { modified_at: string }, existing?: { modified_at: string; is_snapshot?: boolean }): boolean =>
  !existing || !!existing.is_snapshot || serverTimestampKey(incoming.modified_at) >= serverTimestampKey(existing.modified_at);
